import { render } from "./batteryReturn.vue?vue&type=template&id=02a81358&scoped=true"
import script from "./batteryReturn.vue?vue&type=script&lang=js"
export * from "./batteryReturn.vue?vue&type=script&lang=js"

import "./batteryReturn.vue?vue&type=style&index=0&id=02a81358&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a81358"]])

export default __exports__